<template>
<div id="DPEBBHome" >
<b-modal id="modal-sm" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
    <div slot="default">
    <div class='alert alert-danger' role='alert'> Downloading user file, please wait.... <br>  </div>
    <div class="text-center justify-content-center row col-12">
        <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
        <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize" :sizeUnit="unit"></rise-loader> 
        <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
    </div>          
    </div>  
</b-modal>
<Subtitle v-bind:ServiceID="this.AppServiceID" v-bind:MainPage="true">
   <template v-slot:header>
    <i class="fas fa-igloo"></i><b>Administration Home: File Download</b>
  </template> 
</Subtitle>
<Card>
<CardBody>
<p>Any personal health information accessed through the Administration application is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed.
</p>
<TileNote>
<strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES.
</TileNote>
<!-- <button type="button" v-if="AllAppLevel" v-on:click="Go" class="btn btn-primary login_btn"> Back To Main Menu</button> -->
</CardBody>
</Card>

 <div  class="row no-gutters mb-2" v-if="Filedata.length">
    <div class="col-10 pr-2">
   
        <v-client-table :columns="columns" :data="Filedata" :options="options">
         <div slot="beforeTable"  class=" card-header tile-note">
              <b>DPEBB Users File Download :</b>
         </div>
        <span slot="filename" slot-scope="props"> <i class="fa fa-file-text" aria-hidden="true"></i>
        {{ props.row.filename }}
        </span>
        <span slot="foldername" slot-scope="props">  <i class="fa fa-folder" aria-hidden="true"></i>
        {{ props.row.foldername }}
        </span>
        <span slot="download" slot-scope="props" class="pointer" v-on:click="GetFilesByFileName(props.row)"> <i class="fa fa-download" aria-hidden="true"></i>
        </span>
        </v-client-table>

    </div>
 </div>
 
</div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
export default  {
  data: function () {
    return {
        loading: false,
        size: 150,
        Ringsize: 30,
        Risesize: 12,
        margin :'2px',
        unit: 'px',
        color:'#bada55',
        AppServiceID :6,
        Filedata :'',
        columns: ['download','filename','foldername','createddate'],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last', 
              limit:"Records:",
              page:"Page:",
              noResults:"No File Found !",
              filter:"Search File Name:",
              filterPlaceholder:"Search File Name",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          },  
          headings: {
            download: 'Download Files',
            foldername: 'Folder Name',
            filename: 'File Name',
            filepath: 'File Path',
            createddate: 'Created Date',
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          perPage:15,
          perPageValues:[10,15,25,50],
          sortable: ['filename','foldername','createddate'],
          filterable: ['filename','foldername','createddate'],
          dateColumns:['createddate'], 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
        }
    }
  }, 
    components: {

            Card,
            CardBody,
            TileNote,
            Subtitle
        },
    methods: {
          showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            this.boxTwo = value
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
        },
        GetFilesByid(){ 
        var vm = this;
        var url = '/SaskHealthApi/Codes/GetFilesInfo?_='
         var params = new URLSearchParams();         
         axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
            .then(function (response) { 
            //console.log(response.data);
            vm.Filedata = response.data 
            })
            .catch(function (er) {
                console.log(er)
            }).then(function()
            {

            });
          },
        GetFilesByFileName(row){ 
        var vm = this;
        vm.loading=true;
        var url = '/SaskHealthApi/Codes/GetUserFile?_='
         var params = new URLSearchParams({
            "FileName": row.filename,
            "FilePath": row.filepath, 
         });
      
         axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params,responseType: 'blob'})
            .then(function (response) {
                vm.loading=false;


              //const pdfBlob = new Blob([response.data], { type: 'application/pdf;charset-UTF-8' })
              const pdfBlob = new Blob([response.data])  
              const blobUrl = window.URL.createObjectURL(pdfBlob)
              const link = document.createElement('a')
              link.href = blobUrl
              link.setAttribute('download', row.filename)
              link.click();
              link.remove();
              setTimeout(function(){
                // For Firefox it is necessary to delay revoking the ObjectURL
                    URL.revokeObjectURL(link); 
              }, 100);
             
           })
            .catch(function (er) {
              vm.showMsg("File: '"+ row.filename + "' not found",'',' File Download Error');
              vm.loading=false;
                console.log(er)
            }).then(function()
            {
              //vm.loading=false;
            });
          },
 
        Go(){
            this.$router.push('/DPEBB/MainHome')
        }
    },
    computed:{
         UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        },
         AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          }
    },
    created: function() {
        this.$emit('update:layout', LayoutDefault);
        this.GetFilesByid();
    },
    beforeCreate: function() {
        //alert('At Dental ')
         this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
            //this.$store.dispatch('SetBuildMenu');
    },
}
</script>
<style>

</style>
